(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Client.Activity",
                {
                    url: "/Summary",
                    component: "clientActivity",
                    resolve: {
                        clientSummary: ["client", "clientApi", function (client, clientApi) {
                            return clientApi.getClientSummary(client.Id);
                        }],
                        tags: ["clientApi", "client", function (clientApi, client) {
                            return clientApi.getTags(client.Id);
                        }],
                        months: ["months", function (months) {
                            return months;
                        }],
                        timelineEventTypes: ["timelineEventTypes", function (timelineEventTypes) {
                            return timelineEventTypes;
                        }]
                    },
                    data: {
                        pageTitle: "Summary"
                    }
                });
        }
    ]);

    app.component("clientActivity",
        {
            templateUrl: "/App/Client/Activity/client-summary-template.html",
            controller: clientActivityController,
            bindings: {
                currentUser: "<",
                clientSummary: "<",
                client: "<",
                tags: "<",
                timeline: "<",
                months: "<",
                timelineEventTypes: "<"
            }
        });

    function clientActivityController($rootScope, $state, moment, appointmentApi, scheduledTaskApi, clientApi, tagApi, $q, _, $mdDialog, caseApi, $filter, timeLineEventMap, timelineEventFiltersFactory, migratorId, figToaster, modalService, badScheduledTasks, marketingTrackerApi ) {
        var $ctrl = this;
        $ctrl.$state = $state;

        ng.extend($ctrl,
            {
                ui: {
                    startDate: moment().set("year", 1901),
                    endDate: moment().add(3, "months").endOf("month"),
                    timelineFilterResults: []
                },
                modalService: modalService,
                timelineLimit: 10,
                addNote: addNote,
                addTag: addTag,
                removeTag: removeTag,
                transformTag: transformTag,
                searchTags: searchTags,
                selectFilterForTimelineEvents: selectFilterForTimelineEvents,
                timelineEventSatisfiesSearchCriteriaAndFilters: timelineEventSatisfiesSearchCriteriaAndFilters,
                monthAndYearOfEvent: monthAndYearOfEvent
            });

        $rootScope.$on("loadingClientSubstate",
            function () {
                $ctrl.ui.loading = true;
            });

        function addTag(newTag, existingTag) {
            if (newTag !== "" || existingTag !== null) {
                var promises = [];

                // enforce that if a user selects a new tag, and if that tag matches the name (value) of an existingTag, use the existing tag over creating a new tag
                existingTag = _.find($ctrl.searchTagResults, function (tag) {
                    return tag.Value.toUpperCase() === newTag.toUpperCase();
                });
                var tag = !existingTag ? { Value: newTag } : existingTag;

                if (!existingTag) {
                    promises.push(tagApi.add(tag).then(function (response) {
                        tag.Id = response.Id;
                        tag.Value = response.Value;
                    }));
                }

                $q.all(promises).then(function () {
                    $ctrl.searchText = "";
                    $ctrl.selectedItem = "";
                    $ctrl.tags.push(tag);

                    clientApi.addClientTag($ctrl.client.Id, tag);
                });
            }
        }

        function removeTag(tag) {
            return clientApi.removeClientTag($ctrl.client.Id, tag.Id);
        }

        function transformTag(tag) {
            if (tag.Id)
                return tag;
            return { Value: tag };
        }

        function searchTags(term) {
            return tagApi.search(term).then(function (results) {
                // filter the results of the search so they are not already assigned to the client
                $ctrl.searchTagResults = _.filter(results, function (row) {
                    return $ctrl.tags && !_.find($ctrl.tags, function (t) {
                        return t.Value === row.Value;
                    });
                });
                return $ctrl.searchTagResults;
            });
        }

        function addNote(note) {
            if (note) {
                var noteTimelineEvent = {
                    ClientId: $ctrl.client.Id,
                    ScheduledTaskId: null,
                    AppointmentId: null,
                    Description: note,
                    Type: "NoteAdded",
                    CreatedById: $ctrl.currentUser.Id,
                    CreatedBy: $ctrl.currentUser,
                    CreatedOn: new Date().toISOString()
                }
                clientApi.addClientNote($ctrl.client.Id,
                    {
                        ClientId: $ctrl.client.Id,
                        Content: note
                    })
                    .then(function (result) {
                        figToaster.showSimple("Note Created", "bottom");
                        noteTimelineEvent.NoteId = result.Id;
                        if (!$ctrl.timeline) $ctrl.timeline = [];
                        $ctrl.timeline.push(transformTimelineEvent(noteTimelineEvent));
                        $ctrl.timeline = _.chain($ctrl.timeline).orderBy("CreatedOn", "desc").value();
                    });

                $ctrl.note = ""; //clears the form
            }
        }

        function onDeleteNote(noteId, $event) {

            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this note?",
                targetEvent: $event,
                ariaLabel: "Confirm note removal",
                theme: "confirmDelete",
                cancel: "Cancel",
                ok: "Delete",
                skipHide: true,
                multiple: true,
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                return clientApi.removeClientNote($ctrl.client.Id, noteId)
                    .then(function (result) {
                        figToaster.showSimple("Note Deleted", "bottom");
                        $ctrl.timeline = _.filter($ctrl.timeline, function (event) {
                            return event.NoteId !== noteId;
                        });
                    });
            });
        }

        function onUpdateNote(noteId, content, $event) {
            var note = {
                Id: noteId,
                ClientId: $ctrl.client.Id,
                Content: content
            }

            clientApi.updateClientNote($ctrl.client.Id, note)
                .then(function () {
                    figToaster.showSimple("Note Updated", "bottom");
                });

            var index = _.findIndex($ctrl.timeline, function (event) {
                return event.NoteId === noteId;
            });

            var noteTimelineEvent = $ctrl.timeline[index];
            noteTimelineEvent.Description = content;
            noteTimelineEvent.Edited = true;
            $ctrl.timeline[index] = transformTimelineEvent(noteTimelineEvent);
        }

        // Timeline Events
        function onOpenScheduledTask(taskId) {
            $state.go("Home.ScheduledTask", { taskId }, {});
        }

        function onOpenAppointment(appointmentId) {
            $state.go("Home.Appointment", { appointmentId }, {});
        }

        function transformTimelineEvent(event) {
            const newEvent = ng.copy(event);
            if (newEvent.CreatedById === migratorId && !newEvent.CreatedBy) {
                newEvent.CreatedBy = {
                    FirstName: "Initial",
                    LastName: "Migration"
                }
            } else if (!newEvent.CreatedBy) {
                newEvent.CreatedBy = {
                    FirstName: "User",
                    LastName: "Deleted"
                }
            }
            if (timeLineEventMap[newEvent.Type] === undefined) {
                return newEvent;
            }
            return ng.extend(newEvent, timeLineEventMap[newEvent.Type](newEvent, $ctrl.client, onOpenScheduledTask, onOpenAppointment, onDeleteNote, onUpdateNote));
        }

        function monthAndYearOfEvent(event) {
            var eventMonth = $ctrl.months[new Date(event.CreatedOn).getMonth()];
            var eventYear = new Date(event.CreatedOn).getFullYear();
            return eventMonth + " " + eventYear;
        }

        function formatTimeline(events) {
            return _.chain(events)
                .map(transformTimelineEvent)
                .orderBy("CreatedOn", "desc")
                .value();

        }

        function getTimeline(clientId, nextPageToken) {
            return clientApi.getTimeline(clientId, nextPageToken)
                .then(function (timeline) {
                    if (!timeline.NextPage) {
                        return timeline;
                    }
                    return getTimeline(clientId, timeline.NextPage)
                        .then(function (recursiveTimeline) {
                            return timeline = _.concat(timeline, recursiveTimeline);
                        });
                });
        }

        function getMTTimeline(clientEmail) {
            return marketingTrackerApi.getContactEventsByEmailAsync(clientEmail)
                .then(function (mtTimeline) {
                    mtTimeline.forEach(function (timelineEvent, index) {
                        mtTimeline[index].Type = "MarketingEventAttended";
                    });
                    return mtTimeline;
                });
        }

        function constructTimeline() {
            var promises = [];
            $ctrl.ui.timelineLoading = true;
            promises.push(getTimeline($ctrl.client.Id, null));
            if ($ctrl.client.Person.PrimaryEmailAddress)
                promises.push(getMTTimeline($ctrl.client.Person.PrimaryEmailAddress.Value, null));
            $q.all(promises)
                .then(function (results) {
                    // Hotfix: Filter out bad schedlued tasks from timeline (results[0])
                    var timeline = _.filter(results[0], activity => !_.includes(badScheduledTasks, activity.ScheduledTaskId));

                    if (results.length > 1) {
                        // these are events coming from marketing tacker, merge them into the timeline
                        timeline = _.concat(timeline, _.filter(results[1], "Attended"));
                    }
                    $ctrl.timeline = formatTimeline(timeline);
                })
                .catch(function () {
                    return null;
                })
                .finally(function () {
                    $ctrl.ui.timelineLoading = false;
                });
        }

        $rootScope.$on("noteAddedToClient",
            function () {
                constructTimeline();
            });

        // TimelineEvent Filters and Searches
        function timelineEventSatisfiesSearchCriteriaAndFilters(timelineEvent) {
            var filterPassesForTimelineEvent = _.partial(applyFilterFunctionToEvent, _, timelineEvent);
            return _.chain($ctrl.timelineFilters)
                .filter("turnedOn")
                .map("filterEventFunction")
                .push(timelineEventSearchTextContainsSearchString)
                .every(filterPassesForTimelineEvent)
                .value();
        }

        function timelineEventSearchTextContainsSearchString(timelineEvent) {
            if (timelineEvent.searchText)
                return _.includes(timelineEvent.searchText.toUpperCase(), $ctrl.searchTextString.toUpperCase());
        }

        function applyFilterFunctionToEvent(filterEventFunction, timelineEvent) {
            return filterEventFunction(timelineEvent);
        }

        function selectFilterForTimelineEvents(filter) {
            if (filter.turnedOn) {
                turnFilterOff(filter);
            } else {
                turnFilterOn(filter);
            }
        }

        function turnFilterOff(filter) {
            filter.turnedOn = false;
            if (filter.isExclusive) {
                $ctrl.timelineFilters[_.findIndex($ctrl.timelineFilters, { type: filter.type, isDefault: true })].turnedOn = true;
            }
        }

        function turnFilterOn(filter) {
            // When A filter is turned on, we need to shut off other filters of the same filterType (not eventType).
            $ctrl.timelineFilters = _.map($ctrl.timelineFilters,
                function (timelineFilter) {
                    var newFilter = ng.copy(timelineFilter);
                    if (newFilter.type === filter.type) {
                        newFilter.turnedOn = false;
                    }
                    if (newFilter.name === filter.name) {
                        newFilter.turnedOn = true;
                    }
                    return newFilter;
                });
        }

        $ctrl.$onInit = () => {
            constructTimeline();
            $ctrl.timelineFilters = timelineEventFiltersFactory.getFilters($ctrl.currentUser.Id);
            $ctrl.searchTextString = "";
        }
    }

})(window.app, window.angular); //jshint ignore:line